// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__UVXWM","colMaxWidth":"Table_colMaxWidth__36sO-"};